<template>
  <form @submit.prevent="getList()" method="GET" novalidate>
    <div class="card-body">
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="username"
              >Username</label
            >
            <div class="col-md-9">
              <input
                type="text"
                id="username"
                class="form-control"
                v-model="search.username"
                placeholder="Username"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="trx_id">Trx Id</label>
            <div class="col-md-9">
              <input
                type="text"
                id="trx_id"
                class="form-control"
                v-model="search.trx_id"
                placeholder="Trx Id"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="payer_number"
              >Wallet Number</label
            >
            <div class="col-md-9">
              <input
                type="text"
                id="payer_number"
                class="form-control"
                v-model="search.payer_number"
                placeholder="Payer No"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="col-md-3 col-form-label" for="created_at"
              >Created range</label
            >
            <div class="col-md-9">
              <date-picker
                type="datetime"
                input-class="form-control"
                v-model="search.created_at"
                range
                lang="en"
                format="YYYY-MM-DD"
                confirm
                id="created_at"
                value-type="YYYY-MM-DD"
              ></date-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="col-md-3 col-form-label" for="unsubscribed_at"
              >Unsubscribe Date</label
            >
            <div class="col-md-9">
              <date-picker
                type="datetime"
                input-class="form-control"
                v-model="search.unsubscribed_at"
                lang="en"
                format="YYYY-MM-DD"
                confirm
                id="unsubscribed_at"
                value-type="YYYY-MM-DD"
              ></date-picker>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="col-md-3 col-form-label" for="first_subscribed_date"
              >First Subscribed Date</label
            >
            <div class="col-md-9">
              <date-picker
                type="datetime"
                input-class="form-control"
                v-model="search.first_subscribed_date"
                lang="en"
                format="YYYY-MM-DD"
                confirm
                id="first_subscribed_date"
                value-type="YYYY-MM-DD"
              ></date-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="col-md-3 col-form-label" for="last_renewal_date"
              >Last Renewal Date</label
            >
            <div class="col-md-9">
              <date-picker
                type="datetime"
                input-class="form-control"
                v-model="search.last_renewal_date"
                lang="en"
                format="YYYY-MM-DD"
                confirm
                id="last_renewal_date"
                value-type="YYYY-MM-DD"
              ></date-picker>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-9">
              <button type="submit" class="btn btn-common m-2px">
                <i class="fas fa-search"></i> Search
              </button>
              <button
                type="reset"
                class="btn btn-warning"
                @click="resetFilter()"
              >
                <i class="fas fa-undo"></i> Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import { CommonAPI } from "@/services/api";

export default {
  props: ["filter"],
  data: () => ({
    search: {},
    platforms: ["android", "ios", "web"],
    pgws: [],
  }),
  components: {
    DatePicker,
  },
  mounted() {
    //this.getPaymentGateways();
    this.search = this.filter;
  },
  methods: {
    // getPaymentGateways() {
    //   this.is_loading = true;
    //   CommonAPI.paymentGatewayList()
    //     .then((response) => {
    //       this.pgws = response.data;
    //     })
    //     .finally(() => {
    //       this.is_loading = false;
    //     });
    // },
    resetFilter() {
      this.$router.push({ path: this.$route.path }).catch(() => {});
    },
    getList() {
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.search,
        })
        .catch((err) => {
          //console.log(err);
        });
    },
  },
};
</script>
